// extracted by mini-css-extract-plugin
export default {"container":"Nav_container__A9FAB","title_container":"Nav_title_container__guAm7","title":"Nav_title__rU6zu","line":"Nav_line__Rhx1w"};